// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2mETQ","resendInfoText":"OnGoingPaymentBox_resendInfoText__3ZYvf"};